<div class="card">
    <div class="card-header">
        <h2>{{ 'shared.heading.brand-details' | translate }}</h2>
    </div>
    <div class="card-body">
        <div class="heading">
            <img [src]="brand.logo | imageFromApi" alt="Brand logo">
            <div>
                <h3>{{ brand.name }}</h3>
                <small *ngIf="getUniverseList(brand.universes)">
                    <app-expandable-list [list]="getUniverseList(brand.universes)" placeholder="..." limit="5"></app-expandable-list>
                </small>
            </div>
        </div>

        <p>{{ brand.description || '...' }}</p>

        <div *ngIf="brand?.legal_terms">
            <div class="action-link">
                <a (click)="isTermsOpen = !isTermsOpen">
                    {{ (isTermsOpen ? 'shared.button.terms-hide' : 'shared.button.terms-show') | translate }}
                </a>
                <span>{{ (isTermsOpen ? '▲' : '▼' )}}</span>
            </div>

            <div [hidden]="!isTermsOpen" class="terms" [innerHTML]="brand?.legal_terms | newlines"></div>
        </div>
    </div>
</div>
